const positionSelectionDialog = {
  "position.selection.dialog.title": "Select position",
  "position.selection.dialog.actions.random": "Random Positions",
};

const positionSelectionLabels = {
  "position.selection.random.positions": "Random Positions",
  "position.selection.multiple.positions": "Multiple Positions",
  "position.selection.all.phases": "All Phases",
  "position.selection.multiple.phases": "Multiple Phases",
  "position.selection.select.phases": "Select Phases",
  "position.selection.select.all.phases": "Select All",
  "position.selection.clear.all.phases": "Clear All",
};

export const positionSelection = {
  ...positionSelectionDialog,
  ...positionSelectionLabels,
};
